import React from 'react';
import { Button, DialogContentText, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import ImageWithTitleCardButton from './ImageWithTitleCardButton/ImageWithTitleCardButton';

const gif = ['questions-animate.svg', 'call-center-animate.svg', 'business-deal-animate.svg'];

const IntroPage = ({ setIndex, intl }) => {
  return (
    <div>
      <DialogContentText style={{ fontSize: 16 }}>
        {intl.formatMessage({ id: 'adviser-help-intro-title' })}
      </DialogContentText>
      {[1, 2, 3].map((e, index) => (
        <ImageWithTitleCardButton
          key={index}
          index={e}
          title={intl.formatMessage({ id: `adviser-help-intro-question-${e}` })}
          description={intl.formatMessage({ id: `adviser-help-intro-question-subtext-${e}` })}
          imgSrc={'animated-svg/' + gif[index]}
          onClick={() => setIndex(e)}
        />
      ))}
    </div>
  );
};

export default IntroPage;
